import { createFileRoute, Outlet } from '@tanstack/react-router';

import { BackendContainer } from '@/components/backend/BackendContainer';
import { ErrorAlert } from '@/components/errors/ErrorAlert';
import { backendApiAdminLevelsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';
import { useAdminLevelQuery } from '@/queries/useAdminLevelQuery';

export const Route = createFileRoute('/verwaltung/{-$adminLevelId}')({
  loader: async ({ params: { adminLevelId }, context: { queryClient } }) => {
    if (adminLevelId) {
      await queryClient.ensureQueryData(backendApiAdminLevelsFindOneOptions({ path: { adminLevelId } }));
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { error } = useAdminLevelQuery();

  return error ? (
    <BackendContainer>
      <ErrorAlert error={error} />
    </BackendContainer>
  ) : (
    <Outlet />
  );
}
